import { DealMetricType } from "@vega-api/generated/types/dealMetricType";
import { DateField } from "@vega-core/components/Form/Fields/DateField";
import { InputField } from "@vega-core/components/Form/Fields/InputField";
import { MoneyField } from "@vega-core/components/Form/Fields/MoneyField";
import { type CoreCurrency } from "@vega-core/models/money";
import { m } from "@vega-core/paraglide/messages";

type MetricValueFieldProps = {
  metricType?: DealMetricType;
  fieldName: string;
  editable?: boolean;
  dealCurrency?: CoreCurrency;
};

export const MetricValueField = ({
  metricType,
  fieldName,
  editable,
  dealCurrency,
}: MetricValueFieldProps) => {
  const label = m.coInvestments_lpDealOverviewContent_value();

  switch (metricType) {
    case DealMetricType.DATE:
      return (
        <DateField
          disabled={!editable}
          isOptional={false}
          label={label}
          name={fieldName}
        />
      );
    case DealMetricType.MONEY:
      return (
        <MoneyField
          allowAbbreviations
          currency={dealCurrency}
          disabled={!editable}
          isRequired
          label={label}
          name={fieldName}
        />
      );
    default:
      return (
        <InputField
          disabled={!editable}
          isOptional={false}
          label={label}
          name={fieldName}
          placeholder={m.coInvestments_lpDealOverviewContent_enterValue()}
        />
      );
  }
};
